import api from "@/services/api";

import { SET_USER } from "@/store/mutation-types";

export default {
  async request(_, { provider, host }) {
    try {
      const { payload } = await api.oauth[provider].request({ host });
      const { url } = payload;

      if (url) {
        window.location = url;
      }
    } catch (error) {
      console.error(error);
    }
  },
  async login({ commit, dispatch, rootGetters }, { provider, data }) {
    try {
      const { payload } = await api.oauth[provider].login(data);

      api.setAuthorizationHeader(`Bearer ${payload.token}`);

      commit(`user/${SET_USER}`, payload, { root: true });
      dispatch("playlists/fetch", {}, { root: true });

      localStorage.setItem("user", JSON.stringify(rootGetters["user/user"]));
    } catch (error) {
      console.error(error);
    }
  }
};
